var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 3.16659V14.1666C5.33301 14.6528 5.52616 15.1191 5.86998 15.4629C6.2138 15.8068 6.68011 15.9999 7.16634 15.9999H14.4997C14.9859 15.9999 15.4522 15.8068 15.796 15.4629C16.1399 15.1191 16.333 14.6528 16.333 14.1666V6.13842C16.333 5.89418 16.2841 5.65241 16.1894 5.42731C16.0946 5.20221 15.9558 4.99831 15.7812 4.82759L12.7424 1.85575C12.3999 1.52085 11.9399 1.33331 11.4609 1.33325H7.16634C6.68011 1.33325 6.2138 1.52641 5.86998 1.87022C5.52616 2.21404 5.33301 2.68036 5.33301 3.16659V3.16659Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 15.9998V17.8332C12.6665 18.3194 12.4733 18.7857 12.1295 19.1295C11.7857 19.4734 11.3194 19.6665 10.8332 19.6665H3.49984C3.01361 19.6665 2.54729 19.4734 2.20347 19.1295C1.85966 18.7857 1.6665 18.3194 1.6665 17.8332V7.74984C1.6665 7.26361 1.85966 6.79729 2.20347 6.45347C2.54729 6.10966 3.01361 5.9165 3.49984 5.9165H5.33317",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.4bf7a05918c33a0214da3efaa50eb73b.svg";
export { ForwardRef as ReactComponent };